module.exports = __webpack_public_path__ + "img/morningstar.6e6f8b54.svg";